import type { ReactNode, ReactElement, MouseEvent } from "react";
import { cloneElement, Children } from "react";
import cx from "classnames";

interface SelectProps {
  value: string;
  onChange: (value: string) => void;
  children: Array<ReactElement>;
}

export function Select({ value, onChange, children }: SelectProps) {
  return (
    <ul className="TimePicker">
      {Children.map(children, (child) => {
        const itemValue = child.props.value;
        const selected = itemValue === value;
        const disabled = child.props.disabled;

        const newProps = {
          selected,
          ...(disabled || selected
            ? null
            : { onClick: () => onChange(itemValue) }),
        };

        return <li>{cloneElement(child, newProps)}</li>;
      })}
    </ul>
  );
}

interface OptionProps {
  value: string;
  onClick?: (e: MouseEvent) => void;
  selected?: boolean;
  disabled?: boolean;
  disabledReason?: string;
  children: ReactNode;
  seats: number;
}

export function Option({
  selected,
  disabled,
  disabledReason,
  children,
  onClick,
  seats,
}: OptionProps) {
  const className = cx({
    TimePickerOption: true,
    "TimePickerOption--disabled": disabled,
    "TimePickerOption--selected": selected,
  });

  return (
    <span
      className={className}
      aria-selected={selected}
      aria-disabled={disabled}
      onClick={onClick}
    >
      {children}
      {seats > 1 && seats < 4 && !disabled ? (
        <span className="TimePickerOptionLowSeats">{seats} Spots Left</span>
      ) : null}
      {seats === 1 && !disabled ? (
        <span className="TimePickerOptionLowSeats">{seats} Spot Left</span>
      ) : null}

      {disabled && disabledReason ? (
        <span className="TimePickerOptionDisabledReason">{disabledReason}</span>
      ) : null}
    </span>
  );
}
